export default function PHP_StaticProperties() {
  return (
    <div>
      <h1>PHP_StaticProperties</h1>
    </div>
  );
}
